/* eslint-disable jsx-a11y/no-static-element-interactions */

import { Text } from '@audio-network/componentlibrary'
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'
import { MouseEventHandler, TouchEventHandler } from 'react'

import { useSliders } from './Duration.hooks'
import styles from './Duration.module.css'

const Duration = (
	props: React.DetailedHTMLProps<
		React.HTMLAttributes<HTMLDivElement>,
		HTMLDivElement
	>
): JSX.Element => {
	const {
		handleInput,
		handleMouseDown,
		minInputRef,
		maxInputRef,
		minTextRef,
		maxTextRef,
		minThumbRef,
		maxThumbRef,
		slidersRef,
		spaceBetweenRef,
		SLIDER_LIMIT,
		STEP,
		notches,
		handleNotchClick,
		handleLabelInput,
		handleLabelKeydown,
		handleLabelBlur,
		handleLabelFocus,
	} = useSliders()

	const { t } = useTranslation(['search'])

	return (
		<div className={styles.duration} data-testid={t('duration')} {...props}>
			<div className={styles.labelWrapper} data-testid="duration-label">
				<Text
					aria-label={t('duration-min')}
					aria-multiline="false"
					className={styles.label}
					contentEditable
					onBlur={() => handleLabelBlur('min')}
					onFocus={handleLabelFocus}
					onInput={() => handleLabelInput('min')}
					onKeyDown={(event: React.KeyboardEvent) =>
						handleLabelKeydown(event, 'min')
					}
					role="textbox"
					suppressContentEditableWarning
					ref={minTextRef}
				></Text>
				{' - '}
				<Text
					aria-label={t('duration-max')}
					aria-multiline="false"
					className={styles.label}
					contentEditable
					onBlur={() => handleLabelBlur('max')}
					onFocus={handleLabelFocus}
					onInput={() => handleLabelInput('max')}
					onKeyDown={(event: React.KeyboardEvent) =>
						handleLabelKeydown(event, 'max')
					}
					role="textbox"
					suppressContentEditableWarning
					ref={maxTextRef}
				></Text>
			</div>
			<div
				className={styles.sliders}
				onMouseDown={
					handleMouseDown as unknown as MouseEventHandler<HTMLDivElement>
				}
				onTouchStart={
					handleMouseDown as unknown as TouchEventHandler<HTMLDivElement>
				}
				ref={slidersRef}
				tabIndex={-1}
			>
				<span
					className={clsx(styles.thumb, styles.min)}
					data-thumb="min"
					ref={minThumbRef}
				>
					<input
						aria-label={t('duration-min')}
						className={styles.range}
						data-input="min"
						min={0}
						max={SLIDER_LIMIT - STEP}
						onInput={(event) => handleInput(event, 'min')}
						ref={minInputRef}
						type="range"
						step={STEP}
						list="duration-list"
					/>
				</span>
				<span className={styles.spaceBetween} ref={spaceBetweenRef} />
				<span
					className={clsx(styles.thumb, styles.max)}
					data-thumb="max"
					ref={maxThumbRef}
				>
					<input
						aria-label={t('duration-max')}
						className={styles.range}
						data-input="max"
						onInput={(event) => handleInput(event, 'max')}
						ref={maxInputRef}
						type="range"
						min={STEP}
						max={SLIDER_LIMIT}
						step={STEP}
						list="duration-list"
					/>
				</span>
			</div>
			<div className={styles.durationList} id="duration-list">
				{notches.map((notch) => (
					<button
						className={styles.notch}
						key={notch.value}
						onClick={() => {
							handleNotchClick(notch.value)
						}}
					>
						<span className={styles.notchLabel}>{notch.label}</span>
					</button>
				))}
			</div>
		</div>
	)
}
export default Duration
